import { UpdateType } from '@debbie/common/dist/updates/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useUpdatesByRefId } from '@debbie/cortex/dist/updates/index.js';
import React from 'react';
import { CopyToClipboard } from '..//index.js';
const FsNumbers = (props) => {
    const updatesLoadable = useUpdatesByRefId(props.caseId);
    const updates = h.hasData(updatesLoadable) ? updatesLoadable.data : null;
    const fsNumbers = updates &&
        updates.filter((u) => u.updateTypeId === UpdateType.FSNUMMER && u.update);
    if (!fsNumbers || fsNumbers.length === 0) {
        return null;
    }
    return (React.createElement("p", { style: { fontSize: '0.8em' } },
        React.createElement("small", null, "FS-number"),
        React.createElement("div", { style: {
                fontFamily: "'Courier New', Courier, monospace !important",
                fontWeight: 'bold',
            } }, fsNumbers.map((u) => (React.createElement(CopyToClipboard, { key: u.updateId, text: u.update || undefined }, u.update))))));
};
export default FsNumbers;
//# sourceMappingURL=FsNumbers.js.map